var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
// コンポーネントの設定
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    // クラス
    function App() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.title = 'SmartUQ(bata)';
        _this.SmartUQ_logo = './static/img/SmartUQ_logo.png';
        _this.background_img1 = './static/img/background.png';
        _this.footer_rireki = './static/img/icon_rireki_on_x2.png';
        _this.footer_settei = './static/img/icon_settei_on_x2.png';
        _this.footer_sinsei = './static/img/icon_sinsei_on_x2.png';
        _this.footer_kintai = './static/img/icon_kintai_on_x2.png';
        return _this;
    }
    App.prototype.mounted = function () { };
    App = __decorate([
        Component({
            name: 'app',
            watch: {
                '$route': function (toRoute, fromRoute) {
                    console.log("\u73FE\u5728\u306Epath\uFF1A" + toRoute.path);
                }
            },
            methods: {
                check: function () {
                }
            }
        })
        // クラス
    ], App);
    return App;
}(Vue));
export default App;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
// module id = 152
// module chunks = 1